"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var r = Object.defineProperty;
var E = Object.getOwnPropertyDescriptor;
var m = Object.getOwnPropertyNames;
var A = Object.prototype.hasOwnProperty;
var d = function d(F, o) {
    for (var t in o) {
      r(F, t, {
        get: o[t],
        enumerable: !0
      });
    }
  },
  g = function g(F, o, t, s) {
    if (o && typeof o == "object" || typeof o == "function") {
      var _iterator = _createForOfIteratorHelper(m(o)),
        _step;
      try {
        var _loop = function _loop() {
          var e = _step.value;
          !A.call(F, e) && e !== t && r(F, e, {
            get: function get() {
              return o[e];
            },
            enumerable: !(s = E(o, e)) || s.enumerable
          });
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    return F;
  };
var i = function i(F) {
  return g(r({}, "__esModule", {
    value: !0
  }), F);
};
var l = {};
d(l, {
  black: function black() {
    return n;
  },
  green: function green() {
    return a;
  },
  orange: function orange() {
    return p;
  },
  red: function red() {
    return x;
  },
  violet: function violet() {
    return f;
  },
  white: function white() {
    return c;
  }
});
module.exports = i(l);
var c = {
  100: "#FFFFFF"
};
var n = {
  100: "#0B2242",
  80: "#232628",
  60: "#495057",
  50: "#8590A0",
  40: "#ced4da",
  20: "#e9ecef",
  10: "#fafafa"
};
var a = {
  100: "#20D69D",
  50: "#8FEACE",
  10: "#E9FBF5"
};
var p = {
  100: "#FFBB40",
  50: "#FFDDA0",
  10: "#FFF8EC"
};
var x = {
  100: "#F15928",
  50: "#F15928",
  10: "#FEEEEA"
};
var f = {
  100: "#5950EC",
  50: "#FFFFFF",
  10: "#ACA8F5",
  "05": "#F7F6FE"
};